<template>
	<v-card class="w-100 rounded-1 elevation-1 cta-card w-100">
		<div class="w-100 flex-center cta-card-content">
			<v-row class="w-100">
				<v-col class="flex-start flex-column pa-md-15 pa-10" lg="8" sm="12" cols="12">
					<h2
						class="w-100 text-high-emphasis font-weight-regular text-md-h3 text-h4 text-left mb-3"
						style="line-height: 1.25">
						Your AI Co-Founder, Not Just Another Chatbot
					</h2>
					<p class="w-100 text-medium-emphasis font-weight-light medium-text text-left">
						Because it's powered by your business plan and everything you've built inside AIgenerator: this
						isn't just another chatbot. This is your context-aware, business-smart co-founder.
					</p>

					<v-row class="w-100 my-5">
						<v-col cols="12" md="6" class="d-flex align-center justify-start pb-2 pr-5">
							<v-icon class="mr-2" color="success" size="large">mdi-check</v-icon>

							Understands your goals and niche
						</v-col>

						<v-col cols="12" md="6" class="d-flex align-center justify-start pb-2 pr-5">
							<v-icon class="mr-2" color="success" size="large">mdi-check</v-icon>

							Knows your customer, offer, and positioning
						</v-col>
						<v-col cols="12" md="6" class="d-flex align-center justify-start pb-2 pr-5">
							<v-icon class="mr-2" color="success" size="large">mdi-check</v-icon>

							Handles complex business & marketing tasks
						</v-col>
						<v-col cols="12" md="6" class="d-flex align-center justify-start pb-2 pr-5">
							<v-icon class="mr-2" color="success" size="large">mdi-check</v-icon>

							Available 24/7 with tailored answers
						</v-col>
					</v-row>

					<v-btn size="large" variant="outlined" class="mt-4 normal-spacing w-smm-100" :href="ctaLink">
						Try Now for Free
					</v-btn>
				</v-col>
				<v-col class="flex-center align-self-end h-100 flex-column px-8 pr-md-15" lg="4" sm="12" cols="12">
					<img
						src="../../assets/shakehand.png"
						alt="Handshake"
						class="cta-card-image"
						style="max-width: 500px; width: 125%" />
				</v-col>
			</v-row>
		</div>

		<div class="w-100 cta-card-overlay"></div>
	</v-card>
</template>

<script>
	export default {
		name: "CtaCardOne",
		props: {
			ctaLink: {
				type: String,
				required: true,
			},
		},
	}
</script>
